import styled from 'styled-components';
import { rgba } from 'polished';
import Popper from '@material-ui/core/Popper';

// CONSTANTS
import colors, {
  MAIN_BLACK,
  WHITE,
  RADICAL_RED,
  PORCELAIN,
  ROYAL_BLUE_2,
} from '@/constants/colors';

// UTILITY
// import breakpoints from '@/utility/breakpoints';

const { appCard } = colors;

// reduced app card right padding in tooltip (avoid different size effect)
const PADDING = 8;

export const TooltipPopperComponent = styled(Popper)`
  z-index: 1210;

  .MuiTooltip-tooltip {
    min-width: ${p => `${p.$cardWidth - PADDING + 237}px`};
    min-height: ${p => `${p.$cardHeight}px`};
    padding: 0;
    margin: 0;
    border-radius: 8px;
    box-shadow: 8px 8px 16px ${rgba(MAIN_BLACK, 0.25)};
    background-color: ${WHITE};
  }

  .app-card__content {
    width: ${p => `${p.$cardWidth}px`} !important;
  }

  .MuiTooltip-tooltipPlacementRight {
    margin-left: ${p => `-${p.$cardWidth}px`};

    .app-card-content__section {
      margin-left: ${`-${PADDING}px`};
    }
  }

  .MuiTooltip-tooltipPlacementLeft {
    margin-right: ${p => `-${p.$cardWidth}px`};

    .app-card-content {
      flex-direction: row-reverse;

      &__section {
        margin-right: ${`-${PADDING}px`};
        &::before {
          left: auto;
          right: 0;
        }
      }
    }
  }
`;

export const AppCardContainer = styled.div`
  .app-card,
  &.app-card {
    position: relative;
    background-color: ${appCard.bg};
    color: ${p => p.theme.palette.text.primary};
    border-radius: 8px;
    min-height: 393px;
    display: block;

    &__chip {
      ${p =>
        p.theme.palette?.appCard?.freeTrialText &&
        `color: ${p.theme.palette.appCard.freeTrialText};`}
      ${p =>
        p.theme.palette?.appCard?.freeTrialBg &&
        `background-color: ${p.theme.palette.appCard.freeTrialBg};`}
    }

    &__content {
      padding: 50px 24px 24px;
    }

    &__marker {
      &-deal {
        position: absolute;
        top: 5px;
        left: auto;
        right: 5px;
        transform: translate(50%, -50%);
      }

      &-live-tv {
        font-size: 32px;
      }
    }

    &__markers {
      position: absolute;
      width: 100%;
      padding: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      overflow: hidden;
      z-index: 2;

      i {
        display: inline-flex;
      }

      > :not(:last-child) {
        margin-right: 5px;
      }
    }

    &__logo {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 80px;

      img {
        width: auto;
        max-width: 100%;
        max-height: 80px;
      }
    }

    &__title {
      color: ${p => p.theme.palette.text.primary};
      line-height: 2.4rem;
    }

    &__price-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 40px;

      &__cost {
        color: ${appCard.cost};
      }

      &--with-deal {
        .app-card__price-container__cost {
          margin-bottom: 0;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            right: -3px;
            left: -3px;
            top: 50%;
            transform: translate(0, -50%);
            height: 1px;
            background-color: ${RADICAL_RED};
          }
        }
      }
    }

    &__rating {
      text-align: center;
      line-height: 3rem;
      font-size: 1.8rem;
    }

    &__description {
      height: 60px;
      overflow: hidden;
      text-align: center;
    }

    &__button {
      font-size: 1.4rem;
      line-height: 1.4rem;
      z-index: 2;
    }

    &__link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    &--sr {
      .app-card__link {
        display: none;
      }
    }
  }

  &.app-card {
    &--type-promotions {
      .app-card__price-container--with-deal {
        line-height: 1.8rem;
        text-align: center;

        span:nth-child(2) {
          color: ${ROYAL_BLUE_2};
        }
      }

      .app-card__description {
        height: 90px;
      }
    }
  }
`;

export const AppCardContentStyled = styled.div`
  .app-card-content,
  &.app-card-content {
    display: flex;
    width: 100%;

    &__section {
      padding: 24px 16px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;

      &::before {
        content: '';
        position: absolute;
        top: 32px;
        bottom: 32px;
        left: 0;
        right: auto;
        width: 1px;
        background-color: ${p =>
          p.theme.overrides.MuiDivider.root?.backgroundColor || p.theme.palette.divider};
      }
    }

    &__title {
      color: ${p => p.theme.palette.text.secondary};
      margin-bottom: 8px;
    }

    &__list {
      display: flex;

      .MuiGrid-container {
        margin: -3px;
      }

      .MuiGrid-item {
        padding: 3px;
      }

      &--genres {
        max-height: 58px;

        .MuiGrid-container {
          margin: -2px;
        }

        .MuiGrid-item {
          padding: 2px;
        }
      }
    }

    &__card {
      &--device {
        width: 64px;
        height: 42px;
        padding: 1px;
        border-radius: 4px;
        background-color: ${PORCELAIN};

        pointer-events: none;

        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: calc(100% - 2px);
          max-height: calc(100% - 2px);
        }
      }
    }

    &__button {
      margin-top: auto;
      font-size: 1.4rem;
      line-height: 1.4rem;
    }
  }
`;

export default AppCardContainer;
